import { Add } from '@styled-icons/fluentui-system-regular';
import Allow from 'components/Allow';
import Title from 'components/Title';
import { enumRules } from 'enum/enumRules';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TableProductGroups from './Components/TableProductGroups';
import { Container } from './styles';

export const ProductGroup: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Title>Grupos de Produtos</Title>
      <Row>
        <Allow ruleId={enumRules.ProductGroup.CanWriteProductGroup}>
          <Col xs={12} sm={6}>
            <Button
              variant="outline-primary"
              title="Adicionar Produto"
              onClick={() => navigate('addEditProductGroup')}
            >
              <Add size="20" />
            </Button>
          </Col>
        </Allow>
      </Row>
      <br />
      <TableProductGroups />
    </Container>
  );
};
